export default {

    state: {
        user_client_list: null,
    },

    actions: { 
        fetchClientList({ commit }) {
            axios.get('/api/admin/clients/ids/all').then(({data}) => {
                commit('setClients', data);
            });
        }
    },

    mutations: {
        setClients(state, user_client_list) {
            state.user_client_list = user_client_list;
        }
    },
};